import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfigDev = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY_DEV,
  authDomain: "scany-dev.firebaseapp.com",
  projectId: "scany-dev",
  storageBucket: "scany-dev.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID_DEV,
  appId: import.meta.env.VITE_FIREBASE_APP_ID_DEV,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID_DEV
};

const firebaseConfigProd = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY_PROD,
  authDomain: "scany-b6503.firebaseapp.com",
  projectId: "scany-b6503",
  storageBucket: "scany-b6503.appspot.com",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID_PROD,
  appId: import.meta.env.VITE_FIREBASE_APP_ID_PROD,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID_PROD
};

const firebaseConfig = import.meta.env.MODE === 'production' 
  ? firebaseConfigProd 
  : firebaseConfigDev;

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Analytics
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;
